'use client';

// Hook de traduction typé (namespace 'common' par défaut). Remplace tout texte
// en dur dans l'UI — jamais de chaîne littérale visible côté composant.

import { useTranslation } from 'react-i18next';

export function useT(ns: string = 'common') {
  return useTranslation(ns);
}
